import { render, staticRenderFns } from "./SelectProvince.vue?vue&type=template&id=6542a098&"
import script from "./SelectProvince.vue?vue&type=script&lang=js&"
export * from "./SelectProvince.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports